<ul class="wm-default-menu dropdown-menu dropdown-menu-right vcs-menu">
    <li title="{{locale.LABEL_VCS_MENU_PULL_PROJECT}}">
        <a name="wm-vcs-pull" (click)="callVCSActionFn('pull')">
            <i class="wms wms-vcs-pull"></i><span class="menu-name">{{locale.LABEL_VCS_MENU_PULL_PROJECT}}</span>
        </a>
    </li>
    <li title="{{locale.LABEL_VCS_MENU_PUSH_PROJECT}}" *wmsFeature="preferences.project.vcs.push">
        <a name="wm-vcs-push" (click)="callVCSActionFn('push')">
            <i class="wms wms-vcs-push"></i><span class="menu-name">{{locale.LABEL_VCS_MENU_PUSH_PROJECT}}</span>
        </a>
    </li>
    <li title="{{locale.LABEL_VCS_MENU_VIEW_PROJECT_CHANGES}}" *wmsFeature="preferences.project.vcs.push">
        <a name="wm-vcs-revert" (click)="callVCSActionFn('view')">
            <i class="wms wms-vcs-revert"></i><span
                class="menu-name">{{locale.LABEL_VCS_MENU_VIEW_PROJECT_CHANGES}}</span>
        </a>
    </li>
    <li title="{{locale.LABEL_VCS_MENU_VIEW_HISTORY}}">
        <a name="wm-vcs-log" (click)="callVCSActionFn('commit-history')">
            <i class="wms wms-vcs"></i><span class="menu-name">{{locale.LABEL_VCS_MENU_VIEW_HISTORY}}</span>
        </a>
    </li>
    <li title="{{locale.LABEL_VCS_MENU_ADD_EXTERNAL_PROJECT}}" *wmsFeature="preferences.project.vcs.pushToExternalRepo">
        <a name="wm-vcs-add-external" (click)="callVCSActionFn('pushtoExternalRepo')">
            <i class="wms wms-vcs-add"></i><span class="menu-name">{{locale.LABEL_VCS_MENU_ADD_EXTERNAL_PROJECT}}</span>
        </a>
    </li>
    <li title="{{locale.LABEL_OPEN_IN_VCS}}" *ngIf="projectService.projectEdnDetails.extVcsUrl && studioService.selectedOrganization.mode === 'ORG'">
        <a name="wm-open-in-vcs" [href]="projectService.projectEdnDetails.extVcsUrl" target="_blank">
            <i class="wms wms-vcs"></i><span class="menu-name">{{locale.LABEL_OPEN_IN_VCS}}</span>
        </a>
    </li>
    <li title="{{locale.LABEL_UPDATE_VCS_CREDENTIALS}}" *ngIf="studioService.selectedOrganization.mode === 'ORG' && projectService.teamProjectObject.vcsAccountDTO.developerKeysEnabled">
        <a name="wm-open-in-vcs" (click)="openVCSCredentialsDialog()">
            <i class="wms wms-v-login-service"></i><span class="menu-name">{{locale.LABEL_UPDATE_VCS_CREDENTIALS}}</span>
        </a>
    </li>
</ul>
